import type { TranslationParams } from '@/context/LanguageContext';
import { TOOL_ID_TAKEN_ERROR_NAME } from '@/lib/http/errors';
import { StorageService } from '@/lib/StorageService';

type Translate = (key: string, params?: TranslationParams) => string;

/** Message of a failed tool write; an ID taken by another company gets its own sentence. */
export function toolWriteErrorMessage(
  result: { name?: string; message?: string },
  t: Translate,
  fallbackKey: string
): string {
  if (result.name === TOOL_ID_TAKEN_ERROR_NAME) return t('toolPickers.existingIds.takenElsewhere');
  return result.message ?? t(fallbackKey);
}

/**
 * The pickers list the user's own company. A form where another company is typed (admin,
 * super-admin) keeps plain text fields rather than checking against the wrong list.
 */
export function pickersApplyTo(company: string): boolean {
  const typed = company.trim().toLowerCase();
  if (!typed) return true;
  const own = new StorageService().getCompany();
  return !own || own.trim().toLowerCase() === typed;
}
